import { useEffect, useState } from "react";
import { Navbar } from "../components/site/Navbar";
import { Footer } from "../components/site/Footer";
import { Reveal } from "../components/site/Reveal";
import { VentureCard } from "../components/site/VentureCard";
import { api } from "../lib/api";
import { useTitle } from "../App";

export default function Ventures() {
  useTitle("Our Ventures");
  const [ventures, setVentures] = useState(null);

  useEffect(() => {
    api.get("/content/ventures").then((r) => setVentures(r.data)).catch(() => setVentures([]));
  }, []);

  return (
    <div data-testid="ventures-page" className="bg-midnight text-mist">
      <Navbar />
      <section className="grain pt-[76px]">
        <div className="container-ek py-24 sm:py-28">
          <Reveal>
            <p className="eyebrow mb-4">Portfolio</p>
            <h1 className="max-w-3xl font-display text-4xl font-bold tracking-tight sm:text-6xl">Our Ventures</h1>
            <p className="mt-6 max-w-2xl text-base leading-relaxed text-slate-400 sm:text-lg">
              We're building products and businesses that help people create, make informed decisions and navigate everyday life—from marketing and personal guidance to travel, music, mobility and hospitality.
            </p>
            <p className="mt-4 max-w-2xl text-sm leading-relaxed text-slate-500">
              Ventures marked "In Development" are being built now — enquire to follow their progress or discuss early access.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="pb-24 sm:pb-32">
        <div className="container-ek">
          {ventures === null ? (
            <p className="py-20 text-center text-slate-500">Loading ventures...</p>
          ) : ventures.length === 0 ? (
            <p data-testid="ventures-empty" className="py-20 text-center text-slate-500">Ventures are being prepared — check back shortly.</p>
          ) : (
            <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
              {ventures.map((v, i) => <VentureCard key={v.slug} venture={v} index={i} />)}
            </div>
          )}
        </div>
      </section>
      <Footer />
    </div>
  );
}
